import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import ReactModal from '../../../components/Modal';

const PREFIX = 'ai_tracking.onboarding';

/**
 * The end of the flow: what was set up, and what to expect next.
 *
 * On timing it says only that collecting takes a while. A named day would have to account for
 * the prompt's frequency, the scrape queue and how long each platform takes to answer, and
 * being wrong about it is worse than being vague -- the user would come back on the day, find
 * nothing and conclude the setup failed.
 *
 * The only action is going to the project, because that is where the results will appear and
 * there is nothing else left to do here.
 */
class DoneScreen extends Component {
    render() {
        const { t, isOpen, project, promptCount, onGoToProject, onClose } = this.props;

        return (
            <ReactModal
                modalState={isOpen}
                className="width-sm ai-tracking-modal onboarding-step onboarding-done-step"
                onClose={onClose}
            >
                <h3>{t(`${PREFIX}.done.header`)}</h3>
                <div className="ai-tracking-modal-body">
                    <div className="onboarding-done-summary">
                        {t(`${PREFIX}.done.tracking`, {
                            count: promptCount,
                            project: project?.name,
                        })}
                    </div>
                    <div className="onboarding-done-timing">{t(`${PREFIX}.done.collecting`)}</div>
                </div>
                <div className="ai-tracking-modal-footer">
                    <button
                        type="button"
                        className="button button-filled button-primary width-sm btn"
                        onClick={onGoToProject}
                    >
                        {t(`${PREFIX}.done.go_to_project`)}
                    </button>
                    <button
                        type="button"
                        className="button button-outline button-primary width-sm btn"
                        onClick={onClose}
                    >
                        {t(`${PREFIX}.done.close`)}
                    </button>
                </div>
            </ReactModal>
        );
    }
}

export default withTranslation()(DoneScreen);
